// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { errorErrorsList } from 'redux/modules/notifications'

const removeCommentAttachment = deleteAction => dispatch => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { message } = await deleteAction()
        return message
      } catch (err) {
        console.warn(err)
        dispatch(errorErrorsList(err))
      }
    }
  ))
)

export default removeCommentAttachment
